import { ClassNameProps, StyleProps } from "@hex-insights/core";
import { Icon, IconContainer } from "../../../../Components";

export type ModelIconProps = {
	size?: number;
	color?: string;
	backgroundColor?: string;
} & Partial<ClassNameProps & StyleProps>;

export const announcementModelColor = "var(--theme-colors__blue)";
export const announcementModelBackgroundColor = "var(--theme-colors__blue--background)";

export function AnnouncementModelIcon({
	size,
	color = announcementModelColor,
	backgroundColor = announcementModelBackgroundColor,
	className,
	style,
}: ModelIconProps) {
	return (
		<IconContainer color={backgroundColor} className={className} style={style}>
			<Icon.Megaphone size={size} color={color} />
		</IconContainer>
	);
}

export const calendarEventModelColor = "var(--theme-colors__orange)";
export const calendarEventModelBackgroundColor = "var(--theme-colors__orange--background)";

export function CalendarEventModelIcon({
	size,
	color = calendarEventModelColor,
	backgroundColor = calendarEventModelBackgroundColor,
	className,
	style,
}: ModelIconProps) {
	return (
		<IconContainer color={backgroundColor} className={className} style={style}>
			<Icon.CalendarBlank size={size} color={color} />
		</IconContainer>
	);
}

export const newsletterModelColor = "var(--theme-colors__teal)";
export const newsletterModelBackgroundColor = "var(--theme-colors__teal--background)";

export function NewsletterModelIcon({
	size,
	color = newsletterModelColor,
	backgroundColor = newsletterModelBackgroundColor,
	className,
	style,
}: ModelIconProps) {
	return (
		<IconContainer color={backgroundColor} className={className} style={style}>
			<Icon.NewspaperClipping size={size} color={color} />
		</IconContainer>
	);
}

export const postModelColor = "var(--theme-colors__green)";
export const postModelBackgroundColor = "var(--theme-colors__green--background)";

export function PostModelIcon({
	size,
	color = postModelColor,
	backgroundColor = postModelBackgroundColor,
	className,
	style,
}: ModelIconProps) {
	return (
		<IconContainer color={backgroundColor} className={className} style={style}>
			<Icon.ImagesSquare size={size} color={color} />
		</IconContainer>
	);
}

export const userGroupModelColor = "var(--theme-colors__blue)";
export const userGroupModelBackgroundColor = "var(--theme-colors__blue--background)";

export function UserGroupModelIcon({
	size,
	color = userGroupModelColor,
	backgroundColor = userGroupModelBackgroundColor,
	className,
	style,
}: ModelIconProps) {
	return (
		<IconContainer color={backgroundColor} className={className} style={style}>
			<Icon.Users size={size} color={color} />
		</IconContainer>
	);
}

// =========

export const academicSubjectModelColor = "var(--theme-colors__blue)";
export const academicSubjectModelBackgroundColor = "var(--theme-colors__blue--background)";

export function AcademicSubjectModelIcon({
	size,
	color = academicSubjectModelColor,
	backgroundColor = academicSubjectModelBackgroundColor,
	className,
	style,
}: ModelIconProps) {
	return (
		<IconContainer color={backgroundColor} className={className} style={style}>
			<Icon.Backpack size={size} color={color} />
		</IconContainer>
	);
}

export const academicTermModelColor = "var(--theme-colors__blue)";
export const academicTermModelBackgroundColor = "var(--theme-colors__blue--background)";

export function AcademicTermModelIcon({
	size,
	color = academicTermModelColor,
	backgroundColor = academicTermModelBackgroundColor,
	className,
	style,
}: ModelIconProps) {
	return (
		<IconContainer color={backgroundColor} className={className} style={style}>
			<Icon.Book size={size} color={color} />
		</IconContainer>
	);
}

export const academicYearModelColor = "var(--theme-colors__blue)";
export const academicYearModelBackgroundColor = "var(--theme-colors__blue--background)";

export function AcademicYearModelIcon({
	size,
	color = academicYearModelColor,
	backgroundColor = academicYearModelBackgroundColor,
	className,
	style,
}: ModelIconProps) {
	return (
		<IconContainer color={backgroundColor} className={className} style={style}>
			<Icon.Books size={size} color={color} />
		</IconContainer>
	);
}

export const attendanceStatusModelColor = "var(--theme-colors__blue)";
export const attendanceStatusModelBackgroundColor = "var(--theme-colors__blue--background)";

export function AttendanceStatusModelIcon({
	size,
	color = attendanceStatusModelColor,
	backgroundColor = attendanceStatusModelBackgroundColor,
	className,
	style,
}: ModelIconProps) {
	return (
		<IconContainer color={backgroundColor} className={className} style={style}>
			<Icon.UserCirclePlus size={size} color={color} />
		</IconContainer>
	);
}

export const buildingModelColor = "var(--neutral-colors--tertiary)";
export const buildingModelBackgroundColor = "var(--neutral-colors--stroke)";

export function BuildingModelIcon({
	size,
	color = buildingModelColor,
	backgroundColor = buildingModelBackgroundColor,
	className,
	style,
}: ModelIconProps) {
	return (
		<IconContainer color={backgroundColor} className={className} style={style}>
			<Icon.Warehouse size={size} color={color} />
		</IconContainer>
	);
}

export const buildingFloorModelColor = "var(--neutral-colors--tertiary)";
export const buildingFloorModelBackgroundColor = "var(--neutral-colors--stroke)";

export function BuildingFloorModelIcon({
	size,
	color = buildingFloorModelColor,
	backgroundColor = buildingFloorModelBackgroundColor,
	className,
	style,
}: ModelIconProps) {
	return (
		<IconContainer color={backgroundColor} className={className} style={style}>
			<Icon.SquaresFour size={size} color={color} />
		</IconContainer>
	);
}

export const campusModelColor = "var(--theme-colors__green)";
export const campusModelBackgroundColor = "var(--theme-colors__green--background)";

export function CampusModelIcon({
	size,
	color = campusModelColor,
	backgroundColor = campusModelBackgroundColor,
	className,
	style,
}: ModelIconProps) {
	return (
		<IconContainer color={backgroundColor} className={className} style={style}>
			<Icon.Buildings size={size} color={color} />
		</IconContainer>
	);
}

export const classYearModelColor = "var(--theme-colors__blue)";
export const classYearModelBackgroundColor = "var(--theme-colors__blue--background)";

export function ClassYearModelIcon({
	size,
	color = classYearModelColor,
	backgroundColor = classYearModelBackgroundColor,
	className,
	style,
}: ModelIconProps) {
	return (
		<IconContainer color={backgroundColor} className={className} style={style}>
			<Icon.ChalkboardTeacher size={size} color={color} />
		</IconContainer>
	);
}

export const contractModelColor = "var(--theme-colors__blue)";
export const contractModelBackgroundColor = "var(--theme-colors__blue--background)";

export function ContractModelIcon({
	size,
	color = contractModelColor,
	backgroundColor = contractModelBackgroundColor,
	className,
	style,
}: ModelIconProps) {
	return (
		<IconContainer color={backgroundColor} className={className} style={style}>
			<Icon.Scroll size={size} color={color} />
		</IconContainer>
	);
}

export const courseModelColor = "var(--theme-colors__blue)";
export const courseModelBackgroundColor = "var(--theme-colors__blue--background)";

export function CourseModelIcon({
	size,
	color = courseModelColor,
	backgroundColor = courseModelBackgroundColor,
	className,
	style,
}: ModelIconProps) {
	return (
		<IconContainer color={backgroundColor} className={className} style={style}>
			<Icon.ChalkboardSimple size={size} color={color} />
		</IconContainer>
	);
}

export const courseSectionModelColor = "var(--theme-colors__blue)";
export const courseSectionModelBackgroundColor = "var(--theme-colors__blue--background)";

export function CourseSectionModelIcon({
	size,
	color = courseSectionModelColor,
	backgroundColor = courseSectionModelBackgroundColor,
	className,
	style,
}: ModelIconProps) {
	return (
		<IconContainer color={backgroundColor} className={className} style={style}>
			<Icon.Chalkboard size={size} color={color} />
		</IconContainer>
	);
}

export const discountModelColor = "var(--theme-colors__blue)";
export const discountModelBackgroundColor = "var(--theme-colors__blue--background)";

export function DiscountModelIcon({
	size,
	color = discountModelColor,
	backgroundColor = discountModelBackgroundColor,
	className,
	style,
}: ModelIconProps) {
	return (
		<IconContainer color={backgroundColor} className={className} style={style}>
			<Icon.Tag size={size} color={color} />
		</IconContainer>
	);
}

export const employeeModelColor = "var(--theme-colors__blue)";
export const employeeModelBackgroundColor = "var(--theme-colors__blue--background)";

export function EmployeeModelIcon({
	size,
	color = employeeModelColor,
	backgroundColor = employeeModelBackgroundColor,
	className,
	style,
}: ModelIconProps) {
	return (
		<IconContainer color={backgroundColor} className={className} style={style}>
			<Icon.IdentificationCard size={size} color={color} />
		</IconContainer>
	);
}

export const guardianModelColor = "var(--theme-colors__blue)";
export const guardianModelBackgroundColor = "var(--theme-colors__blue--background)";

export function GuardianModelIcon({
	size,
	color = guardianModelColor,
	backgroundColor = guardianModelBackgroundColor,
	className,
	style,
}: ModelIconProps) {
	return (
		<IconContainer color={backgroundColor} className={className} style={style}>
			<Icon.AddressBook size={size} color={color} />
		</IconContainer>
	);
}

export const homeRoomModelColor = "var(--theme-colors__blue)";
export const homeRoomModelBackgroundColor = "var(--theme-colors__blue--background)";

export function HomeRoomModelIcon({
	size,
	color = homeRoomModelColor,
	backgroundColor = homeRoomModelBackgroundColor,
	className,
	style,
}: ModelIconProps) {
	return (
		<IconContainer color={backgroundColor} className={className} style={style}>
			<Icon.HouseSimple size={size} color={color} />
		</IconContainer>
	);
}

export const homeRoomSectionModelColor = "var(--theme-colors__blue)";
export const homeRoomSectionModelBackgroundColor = "var(--theme-colors__blue--background)";

export function HomeRoomSectionModelIcon({
	size,
	color = homeRoomSectionModelColor,
	backgroundColor = homeRoomSectionModelBackgroundColor,
	className,
	style,
}: ModelIconProps) {
	return (
		<IconContainer color={backgroundColor} className={className} style={style}>
			<Icon.House size={size} color={color} />
		</IconContainer>
	);
}

export const paymentModelColor = "var(--theme-colors__green)";
export const paymentModelBackgroundColor = "var(--theme-colors__green--background)";

export function PaymentModelIcon({
	size,
	color = paymentModelColor,
	backgroundColor = paymentModelBackgroundColor,
	className,
	style,
}: ModelIconProps) {
	return (
		<IconContainer color={backgroundColor} className={className} style={style}>
			<Icon.Money size={size} color={color} />
		</IconContainer>
	);
}

export const permissionGroupModelColor = "var(--theme-colors__blue)";
export const permissionGroupModelBackgroundColor = "var(--theme-colors__blue--background)";

export function PermissionGroupModelIcon({
	size,
	color = permissionGroupModelColor,
	backgroundColor = permissionGroupModelBackgroundColor,
	className,
	style,
}: ModelIconProps) {
	return (
		<IconContainer color={backgroundColor} className={className} style={style}>
			<Icon.LockKey size={size} color={color} />
		</IconContainer>
	);
}

export const quotationModelColor = "var(--theme-colors__blue)";
export const quotationModelBackgroundColor = "var(--theme-colors__blue--background)";

export function QuotationModelIcon({
	size,
	color = quotationModelColor,
	backgroundColor = quotationModelBackgroundColor,
	className,
	style,
}: ModelIconProps) {
	return (
		<IconContainer color={backgroundColor} className={className} style={style}>
			<Icon.Quotes size={size} color={color} />
		</IconContainer>
	);
}

export const reportCardModelColor = "var(--theme-colors__blue)";
export const reportCardModelBackgroundColor = "var(--theme-colors__blue--background)";

export function ReportCardModelIcon({
	size,
	color = reportCardModelColor,
	backgroundColor = reportCardModelBackgroundColor,
	className,
	style,
}: ModelIconProps) {
	return (
		<IconContainer color={backgroundColor} className={className} style={style}>
			<Icon.Exam size={size} color={color} />
		</IconContainer>
	);
}

export const roomModelColor = "var(--neutral-colors--tertiary)";
export const roomModelBackgroundColor = "var(--neutral-colors--stroke)";

export function RoomModelIcon({
	size,
	color = roomModelColor,
	backgroundColor = roomModelBackgroundColor,
	className,
	style,
}: ModelIconProps) {
	return (
		<IconContainer color={backgroundColor} className={className} style={style}>
			<Icon.Square size={size} color={color} />
		</IconContainer>
	);
}

export const serviceModelColor = "var(--theme-colors__blue)";
export const serviceModelBackgroundColor = "var(--theme-colors__blue--background)";

export function ServiceModelIcon({
	size,
	color = serviceModelColor,
	backgroundColor = serviceModelBackgroundColor,
	className,
	style,
}: ModelIconProps) {
	return (
		<IconContainer color={backgroundColor} className={className} style={style}>
			<Icon.ShoppingBag size={size} color={color} />
		</IconContainer>
	);
}

export const studentModelColor = "var(--theme-colors__blue)";
export const studentModelBackgroundColor = "var(--theme-colors__blue--background)";

export function StudentModelIcon({
	size,
	color = studentModelColor,
	backgroundColor = studentModelBackgroundColor,
	className,
	style,
}: ModelIconProps) {
	return (
		<IconContainer color={backgroundColor} className={className} style={style}>
			<Icon.Student size={size} color={color} />
		</IconContainer>
	);
}

export const studentDataConsentModelColor = "var(--theme-colors__blue)";
export const studentDataConsentModelBackgroundColor = "var(--theme-colors__blue--background)";

export function StudentDataConsentModelIcon({
	size,
	color = studentDataConsentModelColor,
	backgroundColor = studentDataConsentModelBackgroundColor,
	className,
	style,
}: ModelIconProps) {
	return (
		<IconContainer color={backgroundColor} className={className} style={style}>
			<Icon.UserList size={size} color={color} />
		</IconContainer>
	);
}
